module.exports = __webpack_public_path__ + "img/MissionStatementN11.bf792c57.png";